const MONTHLY_EXPENSES = {
    PROPERTY_TAX:       'propertyTax',
    DEBT_PAYMENTS:      'debtPayments',
    UTILITIES:          'utilities',
    PROPERTY_INSURANCE: 'propertyInsurance',
    PHONE:              'phone',
    CABLE:              'cable',
    INTERNET:           'internet',
    CONDO_FEES:         'condoFees',
};

const MONTHLY_EXPENSES_DEFAULT_VALUES = {
    [MONTHLY_EXPENSES.PROPERTY_TAX]:       0,
    [MONTHLY_EXPENSES.DEBT_PAYMENTS]:      0,
    [MONTHLY_EXPENSES.UTILITIES]:          185,
    [MONTHLY_EXPENSES.PROPERTY_INSURANCE]: 50,
    [MONTHLY_EXPENSES.PHONE]:              60,
    [MONTHLY_EXPENSES.CABLE]:              20,
    [MONTHLY_EXPENSES.INTERNET]:           60,
    [MONTHLY_EXPENSES.CONDO_FEES]:         0,
};

export { MONTHLY_EXPENSES };
export default MONTHLY_EXPENSES_DEFAULT_VALUES;
